import { Suspense, lazy } from "react";
import { Filter, PrefillPair } from "../../../types/GlobalInterfaces";
import { DrawerProps } from "../DrawerTypes";

const QRScannerDrawerComponent = lazy(
  () => import("./QRScannerDrawerComponent")
);

interface Props extends DrawerProps {
  searchField: string;
  moduleAPIName: string;
  fieldsToUpdate: PrefillPair[];
  recordRequirements: Filter[];
  parentRecord?: Record<string, any>;
}

export default function QRScannerDrawer(props: Props) {
  return (
    <Suspense fallback={<></>}>
      <QRScannerDrawerComponent {...props} />
    </Suspense>
  );
}
